import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackScrollDepth } from "../utilities/tracking";

// Fires a `scroll_depth` dataLayer event the first time the user scrolls past
// each threshold on a given page. Thresholds reset on every route change so
// each page view is measured independently.
const THRESHOLDS = [25, 50, 75, 100];

export default function useScrollDepth() {
  const location = useLocation();
  const fired = useRef(new Set());

  useEffect(() => {
    fired.current = new Set();

    const handleScroll = () => {
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - window.innerHeight;
      // Pages too short to scroll count as 100% viewed.
      const percent =
        scrollable <= 0 ? 100 : Math.min(100, Math.round((window.scrollY / scrollable) * 100));

      THRESHOLDS.forEach((threshold) => {
        if (percent >= threshold && !fired.current.has(threshold)) {
          fired.current.add(threshold);
          trackScrollDepth(threshold);
        }
      });
    };

    // Run once in case the page isn't tall enough to scroll.
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);
}
